"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AvatarS3FileModel", {
    enumerable: true,
    get: function() {
        return AvatarS3FileModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const AvatarS3FileModel = _zod.z.object({
    _id: _zod.z.string(),
    company: _zod.z.instanceof(_bson.ObjectId),
    content_type: _zod.z.string().optional(),
    filename: _zod.z.string(),
    owner: _zod.z.instanceof(_bson.ObjectId).optional(),
    uploadDate: _zod.z.date().optional(),
    uploader: _zod.z.instanceof(_bson.ObjectId).optional(),
    vis_to_emp: _zod.z.boolean().optional(),
    vis_to_everyone: _zod.z.boolean().optional(),
    vis_to_man: _zod.z.boolean().optional()
});
